import { useEffect, useRef, useState } from "react";
import "./ConferenceRegistrationForm.css";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import serverConfig from "../config";
import toast, { Toaster } from "react-hot-toast";

const iconRemove = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-x-circle"
    viewBox="0 0 20 20"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
  </svg>
);

const iconAdd = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-plus-circle"
    viewBox="0 0 20 20"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
  </svg>
);

const iconSend = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-send-check"
    viewBox="0 0 20 20"
  >
    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372zm-2.54 1.183L5.93 9.363 1.591 6.602z" />
    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686" />
  </svg>
);

export default function ConferenceFormAbstract({
  name_conference,
  year_conference,
}) {
  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    email: "",
    affiliazione: "",
    titolo: "",
    abstract: "",
    name_abstract: "",
    presentationType: "oral",
    topic: "",
    coautori: [],
  });

  const [listTopics, setListTopics] = useState(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [siteKey, setSiteKey] = useState(null);
  const [isVerified, setIsVerified] = useState(false);

  const [waitForResponseSend, setWaitForResponseSend] = useState(false);
  //const [responseSendInfo, setResponseSendInfo] = useState(null);
  const [responseSendInfo, setResponseSendInfo] = useState({
    status: null,
    message: "waiting",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormData((prev) => ({ ...prev, [name]: value }));
    setFormData((prev) => ({
      ...prev,
      [name]:
        name == "abstract" || name == "presentationType" || name == "topic"
          ? value
          : value.toUpperCase(),
    }));
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    setIsVerified(true);
  };

  const handleCoauthorChange = (index, field, value) => {
    const updatedCoautori = [...formData.coautori];
    updatedCoautori[index][field] = value;
    setFormData((prev) => ({ ...prev, coautori: updatedCoautori }));
  };

  const addCoauthor = () => {
    if (formData.coautori.length < 20) {
      const nextOrder = formData.coautori.length
        ? Math.max(...formData.coautori.map((c) => c.order)) + 1
        : 1;

      setFormData({
        ...formData,
        coautori: [
          ...formData.coautori,
          { order: nextOrder, nome: "", affiliazione: "" },
        ],
      });
    }
  };

  const removeCoauthor = (indexToRemove) => {
    const updated = formData.coautori.filter((_, i) => i !== indexToRemove);
    setFormData({ ...formData, coautori: updated });
  };

  /*
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      toast.error("Completa il reCAPTCHA!");
      return;
    }
    setWaitForResponseSend(true);

    try {
      const response = await axios.post(
        `${serverConfig.serverUrl}/verify_recaptcha_abstract`,
        {
          recaptchaResponse: recaptchaToken,
          year_conference,
          name_conference,
          formData,
        }
      );

      const status = response.data.success;
      const message = response.data.message || "Risposta dal server";

      setResponseSendInfo({ status, message });

      if (response.data.success) {
        toast.success("Abstract inviato con successo!");
        setFormData({
          nome: "",
          cognome: "",
          email: "",
          affiliazione: "",
          titolo: "",
          abstract: "",
          presentationType: "oral",
          topic: "",
          //coautori: [{ order: 1, nome: "", affiliazione: "" }],
          coautori: [],
        });

        setIsVerified(false);
      } else {
        const error = response.data["message"];
        toast.error(error);
        setResponseSendInfo({ status: false, message: message });
      }
    } catch (err) {
      toast.error("Errore nella comunicazione col server");
      setResponseSendInfo({ status: false, message: "Errore di connessione" });
    }

    setTimeout(() => {
      setWaitForResponseSend(false);
      setResponseSendInfo({ status: null, message: "waiting" });
    }, 5000);
  };
  */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      toast.error("Completa il reCAPTCHA!");
      return;
    }

    setWaitForResponseSend(true);

    try {
      // Costruiamo FormData
      const formDataToSend = new FormData();
      formDataToSend.append("recaptchaResponse", recaptchaToken);
      formDataToSend.append("year_conference", year_conference);
      formDataToSend.append("name_conference", name_conference);

      // Aggiungi i campi dal formData
      Object.entries(formData).forEach(([key, value]) => {
        if (key === "coautori") {
          formDataToSend.append("coautori", JSON.stringify(value));
        } else if (key === "abstract") {
          if (value) {
            formDataToSend.append("abstract", value);
          }
        } else {
          formDataToSend.append(key, value);
        }
      });

      const response = await axios.post(
        `${serverConfig.serverUrl}/verify_recaptcha_abstract`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const status = response.data.success;
      const message = response.data.message || "Risposta dal server";

      setResponseSendInfo({ status, message });

      if (status) {
        toast.success("Abstract inviato con successo!");
        setFormData({
          nome: "",
          cognome: "",
          email: "",
          affiliazione: "",
          titolo: "",
          abstract: "",
          presentationType: "oral",
          topic: "",
          coautori: [],
        });
        setIsVerified(false);
      } else {
        toast.error(message);
        setFormData((prev) => ({ ...prev, abstract: ""}));

      }
    } catch (err) {
      toast.error("Errore nella comunicazione col server");
      setResponseSendInfo({ status: false, message: "Errore di connessione" });
      setFormData((prev) => ({ ...prev, abstract: ""}));
    }

    setTimeout(() => {
      setWaitForResponseSend(false);
      setResponseSendInfo({ status: null, message: "waiting" });
    }, 3000);
  };

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_code_recaptcha`)
      .then((res) => setSiteKey(res.data.siteKey))
      .catch(() => toast.error("Errore nel recupero dei dati"));
  }, []);

  useEffect(() => {
    if (year_conference && name_conference) {
      axios
        .post(`${serverConfig.serverUrl}/get_topics_conference`, {
          year_conference,
          name_conference,
        })
        .then((res) => setListTopics(res.data))
        .catch(() => toast.error("Errore nel recupero dei dati"));
    }
  }, [year_conference, name_conference]);

  const contentResponseSend = ({ status, message }) => {
    let style = {
      marginTop: "15px",
      padding: "10px",
      borderRadius: "5px",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
    };

    let icon = null;

    if (status === null) {
      style = {
        ...style,
        backgroundColor: "#e2e3e5",
        color: "#383d41",
        border: "1px solid #d6d8db",
      };
      icon = <span className="spinner" />;
    } else if (status === true) {
      style = {
        ...style,
        backgroundColor: "#d4edda",
        color: "#155724",
        border: "1px solid #c3e6cb",
      };
      icon = <span className="check-icon" />;
    } else if (status === false) {
      style = {
        ...style,
        backgroundColor: "#f8d7da",
        color: "#721c24",
        border: "1px solid #f5c6cb",
      };
      icon = <span className="cross-icon" />;
    }

    return (
      <div style={style}>
        {icon}
        <span>{message}</span>
      </div>
    );
  };

  const clearForm = () =>
    setFormData({
      nome: "",
      cognome: "",
      email: "",
      affiliazione: "",
      titolo: "",
      abstract: "",
      name_abstract: "",
      presentationType: "oral",
      topic: "",
      //coautori: [{ order: 1, nome: "", affiliazione: "" }],
      coautori: [],
    });

  const fileInputRef = useRef();

  /*
  const handleRemoveFile = () => {
    setFormData((prev) => ({
      ...prev,
      abstract: "",
    }));
  };
  */

  const handleRemoveFile = () => {
    setFormData((prev) => ({
      ...prev,
      abstract: "",
      name_abstract: "",
    }));
    // Svuota anche il campo file nel DOM
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      abstract: file, // 👈 salva l'oggetto File, non solo il nome
      name_abstract: file.name,
    }));
  };

  return (
    <div style={{ padding: "20px" }}>
      <Toaster />
      <button
        onClick={clearForm}
        style={{
          borderRadius: "10px",
          padding: "10px",
          color: "#F5F7FA",
          backgroundColor: "#003366",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          fill="currentColor"
          class="bi bi-stars"
          viewBox="0 0 16 16"
        >
          <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" />
        </svg>
        RIPULISCI FORM
      </button>
      {waitForResponseSend ? (
        contentResponseSend(responseSendInfo)
      ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ textAlign: "center" }}>
            <h3>INVIO ABSTRACT</h3>
          </div>

          {[
            { label: "Nome *", name: "nome", type: "text", required: true },
            {
              label: "Cognome *",
              name: "cognome",
              type: "text",
              required: true,
            },
            {
              label: "Email *",
              name: "email",
              type: "email",
              required: true,
              pattern: "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
              placeholder: "es. mario.rossi@email.com",
            },
            {
              label: "Affiliazione *",
              name: "affiliazione",
              type: "text",
              required: true,
            },
          ].map(({ label, name, type, required, pattern, placeholder }) => (
            <div className="row">
              <div key={name} className="input-group">
                <label>{label}</label>
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  pattern={pattern}
                  placeholder={placeholder}
                />
              </div>
            </div>
          ))}

          <div
            style={{
              boxShadow: "0 0 5px 1px #003366",
              padding: "15px",
              borderRadius: "10px",
            }}
          >
            <div className="input-group">
              <label>Titolo Abstract *</label>
              <input
                type="text"
                name="titolo"
                value={formData.titolo}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-group">
              <label>Carica Abstract *</label>
              <div className="row">
                <label style={{ fontSize: "10px" }}>
                  Il file deve essere rinominato: nome_cognome_oral.doc o
                  nome_cognome_poster.doc
                </label>
              </div>
              {/*}
              <input
                type="file"
                name="abstract"
                onChange={handleFileChange}
                accept=".doc"
                required
              />
              */}
              <input
                type="file"
                name="abstract"
                onChange={handleFileChange}
                accept=".doc"
                required
                ref={fileInputRef}
              />

              {formData.abstract != "" && (
                <>
                  📁 {formData.name_abstract}
                  <button
                    type="button"
                    onClick={() => handleRemoveFile()}
                    style={{
                      marginLeft: "10px",
                      color: "white",
                      backgroundColor: "#d9534f",
                      border: "none",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Rimuovi
                  </button>
                </>
              )}
              {/*}

            {
              label: "Carica Documenti (PDF) *",
              name: "documenti",
              type: "file",
              accept: ".pdf",
              multiple: true,
            },
            */}
            </div>

            <div className="input-group">
              <label>Tipo di Presentazione *</label>
              <select
                name="presentationType"
                value={formData.presentationType}
                onChange={handleChange}
                required
              >
                <option value="oral">Orale</option>
                <option value="poster">Poster</option>
              </select>
            </div>

            {listTopics && (
              <div className="input-group">
                <label>Topic *</label>
                <select
                  name="topic"
                  value={formData.topic}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Seleziona un topic
                  </option>
                  {listTopics
                    .sort((a, b) => a.order - b.order)
                    .map((topic, idx) => (
                      <option key={idx} value={topic.topic}>
                        {topic.topic}
                      </option>
                    ))}
                </select>
              </div>
            )}

            <div style={{ marginTop: "20px" }}>
              <h3>Coautori e Affiliazioni</h3>

              {formData.coautori.map((coautore, index) => (
                <div key={index} className="coauthor-block">
                  <div className="coauthor-fields">
                    <div className="input-group half-width">
                      <label>Nome</label>
                      <textarea
                        rows="1"
                        value={coautore.nome}
                        onChange={(e) =>
                          handleCoauthorChange(index, "nome", e.target.value)
                        }
                        required
                      />
                    </div>

                    <div className="input-group half-width">
                      <label>Affiliazione</label>
                      <textarea
                        rows="1"
                        value={coautore.affiliazione}
                        onChange={(e) =>
                          handleCoauthorChange(
                            index,
                            "affiliazione",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>

                    {formData.coautori.length >= 1 && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <button
                          type="button"
                          onClick={() => removeCoauthor(index)}
                          style={{
                            backgroundColor: "rgba(250, 73, 73, 0.50)",
                            border: "1px solid darkred",
                            borderRadius: "10px",
                          }}
                        >
                          {iconRemove}
                          RIMUOVI
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {formData.coautori.length < 20 && (
                <button
                  type="button"
                  onClick={addCoauthor}
                  style={{
                    backgroundColor: "rgba(0, 171, 0, 0.5)",
                    border: "1px solid darkgreen",
                    borderRadius: "10px",
                  }}
                >
                  {iconAdd}
                  Aggiungi Coautore
                </button>
              )}
              {formData.coautori.length === 20 && (
                <p className="text-sm text-orange-600 mt-1">
                  Hai raggiunto il limite massimo di 20 coautori.
                </p>
              )}
            </div>
          </div>

          {siteKey && (
            <div style={{ margin: "15px 0" }}>
              <ReCAPTCHA sitekey={siteKey} onChange={handleRecaptchaChange} />
            </div>
          )}

          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              disabled={!isVerified}
              style={{
                borderRadius: "10px",
                padding: "10px",
                color: "#F5F7FA",
                backgroundColor: "#003366",
              }}
            >
              {iconSend} INVIA ABSTRACT
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
